import { Box, ButtonProps } from '@mui/material';

interface Props extends ButtonProps {
    text?: string;
    isLoading?: boolean;
    tooltip?: string;
    tooltipdDirection?: 'n' | 'ne' | 'e' | 'se' | 's' | 'sw' | 'w' | 'nw';
}

// Retain callers' layout without letting former screen-specific skins override Bootstrap.
const layoutOnly = (sx: any): any => {
    if (Array.isArray(sx)) return sx.map(layoutOnly);
    if (!sx || typeof sx !== 'object') return undefined;
    return Object.fromEntries(Object.entries(sx).filter(([key]) =>
        !/^(background|color|border|boxShadow|font|textTransform|&)/.test(key)));
};

export default function MyButton({text, children, isLoading, tooltip, tooltipdDirection, sx,
    color = 'primary', variant = 'contained', size = 'small', startIcon, endIcon, disabled,
    className = '', fullWidth, disableElevation, disableRipple, disableFocusRipple,
    focusVisibleClassName, TouchRippleProps, touchRippleRef, href, type = 'button', onClick, ...rest}: Props) {
    const tone = ({error:'danger',inherit:'secondary'} as Record<string,string>)[color] || color;
    const skin = variant === 'outlined' ? `btn-custom-outline-${['primary','secondary','danger'].includes(tone) ? tone : 'primary'}` : variant === 'text' ? 'btn-custom-light' : `btn-custom-${['primary','secondary','danger','warning'].includes(tone) ? tone : 'primary'}`;
    const button = <Box {...rest as any} component={href ? 'a' : 'button'} href={href} type={href ? undefined : type}
        className={`btn btn-custom ${skin} ${size === 'small' ? 'btn-sm' : size === 'large' ? 'btn-lg' : ''} spark-button ${fullWidth ? 'w-100' : ''} ${disabled || isLoading ? 'disabled' : ''} ${className}`}
        sx={layoutOnly(sx)} disabled={disabled || isLoading} aria-disabled={disabled || isLoading || undefined}
        aria-busy={isLoading || undefined} onClick={(event: any) => {if(disabled || isLoading){event.preventDefault();return;}onClick?.(event);}}>
        {isLoading ? <span className="spinner-border spinner-border-sm" aria-hidden="true"/> : startIcon}
        {text}{children}{endIcon}
    </Box>;
    return tooltip ? <span className="d-inline-flex" title={tooltip}>{button}</span> : button;
}
